<template>
  <div v-if="isDownloading">
    <div class="row justify-content-center text-center" style = "" >
      <origami></origami>
    </div> 
    <div class="col"  style="text-align:center">
      <h4>Estamos procesando tu solicitud</h4>
    </div>
  </div>
  <div v-else-if="!isDownloading && sucess">
    <div class="col"  style="text-align:center">
      <i class="zmdi zmdi-assignment-check successIcon"></i>
      <h4>¡Solo falta el último paso!</h4><br>
      <h4>Para que la inscripción sea confirmada en el sistema de gestión,<br>tiene que completar el PASO 3 del instructivo de pre-inscripción que figura en la web:</h4>
      <h4><a href="https://carreras.monserrat.unc.edu.ar/ingreso/" target="_blank">https://carreras.monserrat.unc.edu.ar/ingreso/</a></h4>
      <br>
      <br>
      <button class="btn btn-primary" v-on:click="goHome">Ir a inicio</button>
    </div>
  </div>
  <div v-else>
    <div class="row justify-content-center"></div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <horizontal-stepper
              :steps="demoSteps"
              @completed-step="completeStep"
              @active-step="isStepActive"
              @stepper-finished="post"
              locale="es"
            ></horizontal-stepper>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HorizontalStepper from "vue-stepper";
import DatosPersonales from "./FormPregradoSteps/DatosPersonales.vue";
import DatosDomicilio from "./FormPregradoSteps/DatosDomicilio.vue";
import DatosContacto from "./FormPregradoSteps/DatosContacto.vue";
import DatosDocumentos from "./FormPregradoSteps/DatosDocumentos.vue";
import { mapGetters } from "vuex";
import { HTTPAspirantes, HTTPFront, swal } from '../share';
import {Origami}  from 'vue-loading-spinner';

export default {
  components: {
    HorizontalStepper,
    DatosPersonales,
    DatosDomicilio,
    DatosContacto,
    DatosDocumentos,
    Origami
  },
  data() {
    return {
      isDownloading:false,
      sucess: false,
      level : null,
      demoSteps: [
        {
          icon: "person",
          name: "first",
          title: "Paso 1",
          subtitle: "Datos personales",
          component: DatosPersonales,
          completed: false,
        },
        {
          icon: "location_on",
          name: "second",
          title: "Paso 2",
          subtitle: "Datos de domicilio",
          component: DatosDomicilio,
          completed: false,
        },
        {
          icon: "email",
          name: "second",
          title: "Paso 3",
          subtitle: "Datos de contacto",
          component: DatosContacto,
          completed: false,
        },
        {
          icon: "attach_file",
          name: "second",
          title: "Paso 4",
          subtitle: "Carga de documentos",
          component: DatosDocumentos,
          completed: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getAspirantData","getAspirantDataDocument", "getLevel"])
  },
  mounted(){
    if(!this.$route.params.call.documentTypes.length)
    {
      this.demoSteps.pop();
    }
  },
  methods: {
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    // Executed when @stepper-finished event is triggered
    post() {
      let aspirantData        = this.getAspirantData;
      let aspirantDocument    = this.getAspirantDataDocument;
      let proposalData        = this.$route.params;
      let academicProposalId  = proposalData.proposal.id;
      let callId              = proposalData.call.id;
      this.level              = this.getLevel;

      var formulario          = new FormData();


      let form = {
        aspirant: {
          "first_name"              : this.titleCase(aspirantData[0].name),                               
          "surname"                 : this.titleCase(aspirantData[0].lastName),                           
          "dni_number"              : aspirantData[0].documentNumber,                     
          "cuil_number"             : aspirantData[0].cuilNumber,                         
          "birth_date"              : this.$moment(aspirantData[0].birthDate).format("YYYY-MM-DD")+'T00:00:00.000Z',                          /*  1990-08-13T14:58:43.849Z */
          "birth_country_code"      : aspirantData[0].countrySelected.code_iso_alfa3,     
          "birth_province_code"     : aspirantData[0].provinceSelected.code_iso,          
          "birth_locality"          : aspirantData[0].townOfBirth,                        
          "nationality_country_code": aspirantData[0].nationalitySelected.code_iso_alfa3, 
          "address_country_code"    : aspirantData[1].countrySelected.code_iso_alfa3,     
          "address_province_code"   : aspirantData[1].provinceSelected.code_iso,         
          "address_locality"        : aspirantData[1].location,                           
          "address_zip_code"        : aspirantData[1].postalCode,                         
          "address_neighborhood"    : aspirantData[1].neighborhood,                       
          "address_street"          : aspirantData[1].street,                             
          "address_street_number"   : aspirantData[1].streetNumber,                       
          "address_floor"           : aspirantData[1].floorNumber,                        
          "address_room"            : aspirantData[1].department,                         
          "address_building"        : aspirantData[1].building,                           
          "address_comment"         : aspirantData[1].comment,                            
          "blood_group_id"          : aspirantData[0].bloodGroupSelected.id,              
          "blood_factor_id"         : aspirantData[0].bloodFactorSelected.id,
          "gender_id"               : aspirantData[0].genderSelected.id                  
        },
        "phones"                 : aspirantData[2].phoneNumber,                          
        "emails"                 : aspirantData[2].email,                                 
        "previous_school"        : aspirantData[2].previousSchool,                        
        "notification_channel_id": aspirantData[2].notificationChannelSelected.id,    
        "graduation_year" : aspirantData[2].graduationYear,
        "previous_school_type_id" : aspirantData[2].schoolTypeSelected.id    
        
      }
  

      Object.keys(aspirantDocument).forEach(key => {
        aspirantDocument[key].forEach(file=>{
          formulario.append(key,file, file.name);
        })
      });
      formulario.append('form',  JSON.stringify(form));

      this.isDownloading = true;
      HTTPFront.post('/public/academicproposals/' + academicProposalId + '/calls/' + callId + '/forms', 
        formulario,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType:'blob',
        }
          
      )
      .then(res => {
        this.downloadBlob(res.data,aspirantData[0].documentNumber+'.pdf')
      })
      .catch(error => {
        this.isDownloading = false;
        let status = error.response?error.response.status:500;
        //let message = error.response && error.response.data || 'Servicio temporalmente no disponible';
        switch (status) {
          case 401:
            swal.fire({title: 'Acceso denegado', text: 'No posee permisos para acceder a este servicio.', type: 'warning' });
            break;
          case 409:
            swal.fire({title: 'Datos no guardados', text: error.response.data?error.response.data:'Hubo un conflicto con tus datos. Intenta nuevamente si el problema persiste, contactate con el administrador del sistema.', type: 'warning' });
            break;
          case 404:
            swal.fire({icon: 'error',title: '¡Oops!', text: error.response.details?error.response.details:'Hubo un conflicto con tus datos. Intenta nuevamente, si el problema persiste, contactate con el administrador del sistema.', type: 'warning' });
            break;
          case 422:
            swal.fire({icon: 'error',title: '¡Oops!', text: error.response.details?error.response.details:'El DNI del aspirante ya se encuentra confirmado para esta propuesta. Solo puede ser confirmado una vez.', type: 'warning' });
            break;
          case 500:
            swal.fire({icon: 'error', title: 'Algo salió mal', text: 'No pudimos completar tu inscripción. Intentá más tarde.', type: 'warning' });
            break;
          default:
            swal.fire({icon: 'error', title: 'Algo salió mal', text: 'El servicio no se encuentra disponible. Intentá más tarde.', type: 'warning' });
            break;
        }

      })

    },
    openOnNewTab(blob) {
      blob = blob.slice(0, blob.size, 'application/pdf');
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    },
    downloadBlob(blob, filename) {
      this.isDownloading = false;
      this.sucess = true;
      const link = document.createElement('a');
      blob = blob.slice(0, blob.size,'application/pdf');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
     
    },
    goHome(){
      this.$router.push('/'+this.level);
    },
    titleCase(str) {
      return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
      }).join(' ');
    }
  },
};
</script>
<style >
.successIcon{
  font-size: 56px;
  color:#31855e;
}
</style>